/**
 * Entrypoint for production. This will import the public path from where to laod chunks/assets from
 * ./public path.
 */
import "./publicPath";

const moduleLoading = import("./main");

const StagePlayer = (...args) => {
  moduleLoading.then(module => {
    module.StagePlayer(...args);
  });
};

// Expose getAccessToken / setAccessToken so co-deployed bundles (e.g. marin-stageplayer-embed)
// can share the token without each firing their own portal_refresh.
const getAccessToken = () => {
  // main.jsx loads async; fall back to null if not yet ready
  try {
    // eslint-disable-next-line global-require
    return require("./app/services/portalApi").getAccessToken();
  } catch (e) {
    return null;
  }
};

// Allows the embed to pre-seed the token so StagePlayer's useEffect skips
// its own portal_refresh (avoiding a double-refresh race).
const setAccessToken = token => {
  try {
    // eslint-disable-next-line global-require
    require("./app/services/portalApi").setAccessToken(token);
  } catch (e) {
    // module not yet loaded — token will be fetched by StagePlayer on mount
  }
};

export { StagePlayer, getAccessToken, setAccessToken };
